import { defineMessages } from 'react-intl';

export default defineMessages({
    paPolicyNumber: {
        id: 'policy.view.policy-details.PaPolicyNumber',
        defaultMessage: ' Automobile Policy # {policyNumber}'
    },
    hoPolicyNumber: {
        id: 'policy.view.policy-details.HoPolicyNumber',
        defaultMessage: ' {policyType} Policy # {policyNumber}'
    },
    editCoverages: {
        id: 'policy.view.policy-details.EditCoverages',
        defaultMessage: 'Edit Coverages'
    },
    editPolicy: {
        id: 'policy.view.policy-details.Edit Policy',
        defaultMessage: 'Edit Policy'
    },
    editPolicyNumber: {
        id: 'policy.view.policy-details.Edit Policy Number',
        defaultMessage: 'Edit Policy # {policyNumber}'
    },
    editPolicyTrackButtonIdentifier: {
        id: 'policy.view.policy-details.tracking.Edit Policy',
        defaultMessage: 'Edit Policy'
    },
    submenuItem: {
        id: 'policy.view.policy-details.tracking.Sub-Menu item',
        defaultMessage: 'Sub-Menu item'
    },
    policyMenu: {
        id: 'policy.view.policy-details.PolicyMenu',
        defaultMessage: 'Policy Menu'
    },
    policyDetails: {
        id: 'policy.view.policy-details.PolicyDetails',
        defaultMessage: 'Policy Details'
    },
    billing: {
        id: 'policy.view.policy-details.Billing',
        defaultMessage: 'Billing'
    },
    drivers: {
        id: 'policy.view.policy-details.Drivers',
        defaultMessage: 'Drivers'
    },
    policyDocuments: {
        id: 'policy.view.policy-details.PolicyDocuments',
        defaultMessage: 'Policy Documents'
    },
    homeowners: {
        id: 'policy.view.policy-details.Homeowners',
        defaultMessage: 'Homeowners'
    },
    propertyDetailsAria: {
        id: 'policy.view.policy-details.PropertyDetailsAria',
        defaultMessage: 'button Details for property at the {address}'
    },
    renters: {
        id: 'policy.view.policy-details.Renters',
        defaultMessage: 'Renters'
    },
    condominium: {
        id: 'policy.view.policy-details.Condominium',
        defaultMessage: 'Condominium'
    },
    notice: {
        id: 'policy.common.views.account-policy-details.Notice',
        defaultMessage: 'NOTICE:'
    },
    viewRenewalTerm: {
        id: 'policy.common.views.account-policy-details.View Renewal Term',
        defaultMessage: 'You are viewing the upcoming renewal term of your policy.'
    },
    pendingPolicyChange: {
        id: 'policy.view.policy-details.You have a pending policy change that will occur on',
        defaultMessage: 'You have a pending policy change that will occur on {date}. Online policy changes are temporarily unavailable, until {nextDay}, when your pending change will be completed. Please call us if you’d like to make a policy change and our agents can assist you.'
    },
    pendingPolicyChangeTempUnavailable: {
        id: 'policy.view.policy-details.You have a pending policy change. Online policy changes are temporarily unavailable...',
        defaultMessage: 'You have a pending policy change. Online policy changes are temporarily unavailable, until your pending change is completed. Please call us if you’d like to make a policy change and our agents can assist you.'
    },
    policyAboutToRenew: {
        id: 'policy.view.policy-details.Your policy is about to renew',
        defaultMessage: 'Your policy is about to renew on {date} and online policy changes are temporarily unavailable until your policy renewal. Please call us if you’d like to make a policy change and our agents can assist you.'
    },
    policyAboutToRenewTempUnavailable: {
        id: 'policy.view.policy-details.Your policy is about to renew. Online policy changes are temporarily unavailable until your policy is renewed. Please call us if you’d like to make a policy change and our agents can assist you',
        defaultMessage: 'Your policy is about to renew. Online policy changes are temporarily unavailable until your policy is renewed. Please call us if you’d like to make a policy change and our agents can assist you.'
    },
    policyChangeCannotBeStarted: {
        id: 'policy.view.policy-details.Policy Change cannot be started',
        defaultMessage: 'Policy Change cannot be started.'
    },
    youCanReachUsAt: {
        id: 'policy.view.policy-details.You can reach us at',
        defaultMessage: 'You can reach us by phone &lt;a href="tel:1-800-640-2920"&gt;1-800-640-2920&lt;/a&gt; Monday to Friday 7:30 am to 7:30 pm PT and Saturday 8:00 am to 4:30 pm PT.'
    },
    delinquencyModalTitle: {
        id: 'policy.view.policy-details.Policy Changes Are Temporarily Unavailable',
        defaultMessage: 'Policy Changes Are Temporarily Unavailable'
    },
    delinquencyModalBody: {
        id: 'policy.view.policy-details.Payment is due on your policy in the amount of (amount). Please make your payment below...',
        defaultMessage: 'Payment is due on your policy in the amount of {amount}. Please make your payment below or give us a call. Online policy changes are temporarily unavailable until payment is made.'
    },
    close: {
        id: 'policy.view.policy-details.Close',
        defaultMessage: 'Close'
    },
    offerOfEarthquakeCoverage: {
        id: 'policy.common.directives.templates.policy-documents.Offer of Earthquake Coverage',
        defaultMessage: 'Offer of Earthquake Coverage'
    },
    policyDeclaration: {
        id: 'policy.common.directives.templates.policy-documents.Policy Declaration',
        defaultMessage: 'Policy Declaration'
    },
    inspectionCompany: {
        id: 'policy.common.directives.templates.policy-documents.Adverse inspection results',
        defaultMessage: 'Adverse inspection results'
    },
    attractiveNuisanceIssues: {
        id: 'policy.common.directives.templates.policy-documents.Attractive Nuisance Issues',
        defaultMessage: 'Attractive Nuisance Issues'
    },
    attractiveNuisanceIssuesNonRenewal: {
        id: 'policy.common.directives.templates.policy-documents.Attractive Nuisance, Etc. Issues',
        defaultMessage: 'Attractive Nuisance, Etc. Issues'
    },
    deceasedNonRenewal: {
        id: 'policy.common.directives.templates.policy-documents.Deceased',
        defaultMessage: 'Deceased'
    },
    deleteCommercial: {
        id: 'policy.common.directives.templates.policy-documents.Delete Commercial',
        defaultMessage: 'Delete Commercial'
    },
    DLVehicleIssuesNonRenewal: {
        id: 'policy.common.directives.templates.policy-documents.Driver License or Vehicle Issues',
        defaultMessage: 'Driver License or Vehicle Issues'
    },
    exceedsMaximumLimitIssuesNonRenewal: {
        id: 'policy.common.directives.templates.policy-documents.Exceeds Maximum Limit Issues',
        defaultMessage: 'Exceeds Maximum Limit Issues'
    },
    excludeDriverToObtainRenewal: {
        id: 'policy.common.directives.templates.policy-documents.Exclude Driver to obtain renewal',
        defaultMessage: 'Exclude Driver to obtain renewal'
    },
    forCauseNonRenewal: {
        id: 'policy.common.directives.templates.policy-documents.For Cause',
        defaultMessage: 'For Cause'
    },
    policyChangeForm: {
        id: 'policy.common.directives.templates.policy-documents.Free Form',
        defaultMessage: 'Free Form'
    },
    fullTimeEmployees: {
        id: 'policy.common.directives.templates.policy-documents.Full Time Employees',
        defaultMessage: 'Full Time Employees'
    },
    genericNonRenewal: {
        id: 'policy.common.directives.templates.policy-documents.Underwriting or Generic Non-Renewal',
        defaultMessage: 'Underwriting or Generic Non-Renewal'
    },
    genericCancellation: {
        id: 'policy.common.directives.templates.policy-documents.Generic Cancellation',
        defaultMessage: 'Generic Cancellation'
    },
    ineligibleAnimalIssues: {
        id: 'policy.common.directives.templates.policy-documents.Ineligible Animal Issues',
        defaultMessage: 'Ineligible Animal Issues'
    },
    ineligibleBusinessIssues: {
        id: 'policy.common.directives.templates.policy-documents.Ineligible Business Issues',
        defaultMessage: 'Ineligible Business Issues'
    },
    insuredDeceasedNonRenewal: {
        id: 'policy.common.directives.templates.policy-documents.Insured Deceased',
        defaultMessage: 'Insured Deceased'
    },
    lateRenewal: {
        id: 'policy.common.directives.templates.policy-documents.Late Renewal',
        defaultMessage: 'Late Renewal'
    },
    majorViolationsNonRenewal: {
        id: 'policy.common.directives.templates.policy-documents.Major Violations',
        defaultMessage: 'Major Violations'
    },
    cancelDueToMisrepresentation: {
        id: 'policy.common.directives.templates.policy-documents.Misrepresentation',
        defaultMessage: 'Misrepresentation'
    },
    misrepresentationIssuesNonRenewal: {
        id: 'policy.common.directives.templates.policy-documents.Misrepresentation or Non-Coop',
        defaultMessage: 'Misrepresentation or Non-Coop.'
    },
    cancelDueToMisrepresentationOnClaim: {
        id: 'policy.common.directives.templates.policy-documents.Misrepresentation on claim',
        defaultMessage: 'Misrepresentation on claim'
    },
    missingExclusionPaperwork: {
        id: 'policy.common.directives.templates.policy-documents.Missing Exclusion',
        defaultMessage: 'Missing Exclusion'
    },
    cancelDuetoMissingPaperworkInformation: {
        id: 'policy.common.directives.templates.policy-documents.Missing paperwork/information',
        defaultMessage: 'Missing paperwork/information'
    },
    misrepresentationNonRenewal: {
        id: 'policy.common.directives.templates.policy-documents.Misrepresentation Non-Renewal',
        defaultMessage: 'Misrepresentation'
    },
    moveStateChangedNonRenewal: {
        id: 'policy.common.directives.templates.policy-documents.Moved out of State',
        defaultMessage: 'Moved out of State'
    },
    misrepresentationIssues: {
        id: 'policy.common.directives.templates.policy-documents.Misrepresentation Issues',
        defaultMessage: 'Misrepresentation Issues'
    },
    multipleHomesOnResidence: {
        id: 'policy.common.directives.templates.policy-documents.Multiple Homes on Premises',
        defaultMessage: 'Multiple Homes on Premises'
    },
    MVRNonRenewal: {
        id: 'policy.common.directives.templates.policy-documents.MVR Non-Renewal',
        defaultMessage: 'MVR'
    },
    cancelDueToMVRResults: {
        id: 'policy.common.directives.templates.policy-documents.MVR Cancel',
        defaultMessage: 'MVR'
    },
    signatureNonRenewal: {
        id: 'policy.common.directives.templates.policy-documents.Non-Renewal - Signature',
        defaultMessage: 'Non-Renewal - Signature'
    },
    policyChangeDeclineHO: {
        id: 'policy.common.directives.templates.policy-documents.Policy Change Decline HO',
        defaultMessage: 'Policy Change Decline'
    },
    policyChangeDeclinePA: {
        id: 'policy.common.directives.templates.policy-documents.Policy Change Decline PA',
        defaultMessage: 'Policy Change Decline'
    },
    occupancyIssues: {
        id: 'policy.common.directives.templates.policy-documents.Occupancy Issues',
        defaultMessage: 'Occupancy Issues'
    },
    ownershipIssues: {
        id: 'policy.common.directives.templates.policy-documents.Ownership Issues',
        defaultMessage: 'Ownership Issues'
    },
    ownershipIssuesNonRenewal: {
        id: 'policy.common.directives.templates.policy-documents.Ownership Occupancy or Use Issues',
        defaultMessage: 'Ownership, Occupancy or Use Issues'
    },
    removeVehicleAndOrDriver: {
        id: 'policy.common.directives.templates.policy-documents.Remove Vehicle AND/OR Driver',
        defaultMessage: 'Remove Vehicle AND/OR Driver'
    },
    repairIssues: {
        id: 'policy.common.directives.templates.policy-documents.Repair Issues',
        defaultMessage: 'Repair Issues'
    },
    roommateTenantIssuesNonRenewal: {
        id: 'policy.common.directives.templates.policy-documents.Roommate Tenant Issues',
        defaultMessage: 'Roommate Tenant Issues'
    },
    trusteeOfTrustIssues: {
        id: 'policy.common.directives.templates.policy-documents.Trustee of Trust Issues',
        defaultMessage: 'Trustee of Trust Issues'
    },
    noInspectionIssues: {
        id: 'policy.common.directives.templates.policy-documents.Unable to inspect home',
        defaultMessage: 'Unable to inspect home'
    },
    underwritingIssues: {
        id: 'policy.common.directives.templates.policy-documents.Underwriting Issues',
        defaultMessage: 'Underwriting Issues'
    },
    vacancyIssues: {
        id: 'policy.common.directives.templates.policy-documents.Vacancy Issues',
        defaultMessage: 'Vacancy Issues'
    },
    WildfireAppealDecisionApplication: {
        id: 'policy.common.directives.templates.policy-documents.Wildfire Appeal Decision - Application',
        defaultMessage: 'Wildfire Appeal Decision - Application'
    },
    ANCC: {
        id: 'policy.common.directives.templates.policy-documents.Auto Notice of Coverage Change',
        defaultMessage: 'Auto Notice of Coverage Change'
    },
    CADAP: {
        id: 'policy.common.directives.templates.policy-documents.California Notice of Designated Additional Person',
        defaultMessage: 'California Notice of Designated Additional Person'
    },
    COI: {
        id: 'policy.common.directives.templates.policy-documents.Certificate of Insurance',
        defaultMessage: 'Certificate of Insurance'
    },
    ConsumerReportsDisclosureNotice: {
        id: 'policy.common.directives.templates.policy-documents.Consumer Reports Disclosure',
        defaultMessage: 'Consumer Reports Disclosure'
    },
    CSS: {
        id: 'policy.common.directives.templates.policy-documents.Community Service Statement',
        defaultMessage: 'Community Service Statement'
    },
    HNCC: {
        id: 'policy.common.directives.templates.policy-documents.Homeowners Notice of Coverage Change',
        defaultMessage: 'Homeowners Notice of Coverage Change'
    },
    HNCCC: {
        id: 'policy.common.directives.templates.policy-documents.Homeowners Notice of Coverage C Change',
        defaultMessage: 'Homeowners Notice of Coverage C Change'
    },
    RCN: {
        id: 'policy.common.directives.templates.policy-documents.Important Information - Price Increase Notice',
        defaultMessage: 'Important Information - Price Increase Notice'
    },
    RCNH: {
        id: 'policy.common.directives.templates.policy-documents.Important Information - Price Increase Notice',
        defaultMessage: 'Important Information - Price Increase Notice'
    },
    HomeSharingNonRenewalWarning: {
        id: 'policy.common.directives.templates.policy-documents.Non-Renew Warning - Home Sharing',
        defaultMessage: 'Non-Renew Warning - Home Sharing'
    },
    monthlyRecurringPaymentAuthorization: {
        id: 'policy.common.directives.templates.policy-documents.Monthly Automated Recurring Payment Authorization',
        defaultMessage: 'Monthly Automated Recurring Payment Authorization'
    },
    CAMinimumLiabilityLimitsIncreasedFollowUpEmail: {
        id: 'policy.common.directives.templates.policy-documents.New California Auto Liability Limits Notice',
        defaultMessage: 'New California Auto Liability Limits Notice'
    },
    AdditionalDriverNOC: {
        id: 'policy.common.directives.templates.policy-documents.Notice of Cancellation - Additional Drivers',
        defaultMessage: 'Notice of Cancellation - Additional Drivers'
    },
    carrierInitiatedNOC: {
        id: 'policy.common.directives.templates.policy-documents.Cancellation System Notice - Carrier Initiated',
        defaultMessage: 'Cancellation System Notice - Carrier Initiated'
    },
    insuredInitiatedNOC: {
        id: 'policy.common.directives.templates.policy-documents.Cancellation System Notice - Insured Initiated',
        defaultMessage: 'Cancellation System Notice - Insured Initiated'
    },
    AdditionalDriverLateNonRenewal: {
        id: 'policy.common.directives.templates.policy-documents.Notice of Late Non-Renewal - Additional Drivers',
        defaultMessage: 'Notice of Late Non-Renewal - Additional Drivers'
    },
    AdditionalDriverNonRenewal: {
        id: 'policy.common.directives.templates.policy-documents.Notice of Non-Renewal - Additional Drivers',
        defaultMessage: 'Notice of Non-Renewal - Additional Drivers'
    },
    NSLLC: {
        id: 'policy.common.directives.templates.policy-documents.Notice of Service Line Limit Change',
        defaultMessage: 'Notice of Service Line Limit Change'
    },
    COINOT: {
        id: 'policy.common.directives.templates.policy-documents.Notice of Termination',
        defaultMessage: 'Notice of Termination'
    },
    RID: {
        id: 'policy.common.directives.templates.policy-documents.Receipt of Insurance Disclosure Form',
        defaultMessage: 'Receipt of Insurance Disclosure Form'
    },
    RAIC: {
        id: 'policy.common.directives.templates.policy-documents.Roadside Assistance Identification Cards',
        defaultMessage: 'Roadside Assistance Identification Cards'
    },
    VID: {
        id: 'policy.common.directives.templates.policy-documents.Vehicle Identification Cards',
        defaultMessage: 'Vehicle Identification Cards'
    },
    WildfireAppealAcknowledgement: {
        id: 'policy.common.directives.templates.policy-documents.Wildfire Appeal Acknowledgement',
        defaultMessage: 'Wildfire Appeal Acknowledgement'
    },
    WFRD: {
        id: 'policy.common.directives.templates.policy-documents.Wildfire Risk Disclosure',
        defaultMessage: 'Wildfire Risk Disclosure'
    },
    addExclusionOfNamedDriver: {
        id: 'policy.common.directives.templates.policy-documents.Add Exclusion Of Named Driver',
        defaultMessage: 'Add Exclusion Of Named Driver'
    },
    addExclusionOfNamedDriverFollowUp: {
        id: 'policy.common.directives.templates.policy-documents.Add Exclusion Of Named Driver Follow Up',
        defaultMessage: 'Add Exclusion Of Named Driver Follow Up'
    },
    AddressSlip6x9: {
        id: 'policy.common.directives.templates.policy-documents.Address Slip 6x9',
        defaultMessage: 'Address Slip 6x9'
    },
    advisePNIOfDriverFTA: {
        id: 'policy.common.directives.templates.policy-documents.Advise Driver Expired License or FTA',
        defaultMessage: 'Advise Driver Expired License or FTA'
    },
    adviseSVENotCovered: {
        id: 'policy.common.directives.templates.policy-documents.Advise SVE Not Covered',
        defaultMessage: 'Advise SVE Not Covered'
    },
    AddressSlip9x12: {
        id: 'policy.common.directives.templates.policy-documents.Address Slip 9x12',
        defaultMessage: 'Address Slip 9x12'
    },
    binderLienholderAndLessor: {
        id: 'policy.common.directives.templates.policy-documents.Binder - Lienholder and Lessor',
        defaultMessage: 'Binder - Lienholder and Lessor'
    },
    binderNamedInsured: {
        id: 'policy.common.directives.templates.policy-documents.Binder - Named Insured',
        defaultMessage: 'Binder - Named Insured'
    },
    CDNInsuranceCard: {
        id: 'policy.common.directives.templates.policy-documents.Canadian Insurance Card Letter',
        defaultMessage: 'Canadian Insurance Card Letter'
    },
    changeOfAddressQuestionnaire: {
        id: 'policy.common.directives.templates.policy-documents.Change of Address Questionnaire',
        defaultMessage: 'Change of Address Questionnaire'
    },
    claimsHistoryPA: {
        id: 'policy.common.directives.templates.policy-documents.Claims History PA',
        defaultMessage: 'Claims History'
    },
    claimsHistoryHO: {
        id: 'policy.common.directives.templates.policy-documents.Claims History HO',
        defaultMessage: 'Claims History'
    },
    EmailDistributionConsentUS: {
        id: 'policy.common.directives.templates.policy-documents.Consent for the electronic delivery of policy documents',
        defaultMessage: 'Consent for the electronic delivery of policy documents'
    },
    courtesyToDriverRemoved: {
        id: 'policy.common.directives.templates.policy-documents.Courtesy to Driver Removed',
        defaultMessage: 'Courtesy to Driver Removed'
    },
    deductibleChange: {
        id: 'policy.common.directives.templates.policy-documents.Deductible Change',
        defaultMessage: 'Deductible Change'
    },
    reinstatement: {
        id: 'policy.common.directives.templates.policy-documents.Reinstatement',
        defaultMessage: 'Reinstatement'
    },
    dogBreedInfo: {
        id: 'policy.common.directives.templates.policy-documents.Dog Breed Info',
        defaultMessage: 'Dog Breed Info'
    },
    dwellingLimitLowerThanReplacement: {
        id: 'policy.common.directives.templates.policy-documents.Dwelling Limit Lower than Replacement Cost',
        defaultMessage: 'Dwelling Limit Lower than Replacement Cost'
    },
    EscrowMortgageeNotice: {
        id: 'policy.common.directives.templates.policy-documents.Escrow Mortgagee Notice',
        defaultMessage: 'Escrow Mortgagee Notice'
    },
    exclusionCorrection: {
        id: 'policy.common.directives.templates.policy-documents.Exclusion Correction',
        defaultMessage: 'Exclusion Correction'
    },
    exclusionOfNamedDriverEnd: {
        id: 'policy.common.directives.templates.policy-documents.Exclusion Of Named Driver Endorsement',
        defaultMessage: 'Exclusion Of Named Driver Endorsement'
    },
    fix: {
        id: 'policy.common.directives.templates.policy-documents.Fix',
        defaultMessage: 'Fix'
    },
    fix2ndRequest: {
        id: 'policy.common.directives.templates.policy-documents.Fix 2nd Request',
        defaultMessage: 'Fix 2nd Request'
    },
    fixNotGoodEnough: {
        id: 'policy.common.directives.templates.policy-documents.Fix Not Good Enough',
        defaultMessage: 'Fix Not Good Enough'
    },
    fixRCT: {
        id: 'policy.common.directives.templates.policy-documents.FIX RCT',
        defaultMessage: 'FIX RCT'
    },
    inspectionRequired: {
        id: 'policy.common.directives.templates.policy-documents.Inspection Required',
        defaultMessage: 'Inspection Required'
    },
    inspectionUnableToInspect: {
        id: 'policy.common.directives.templates.policy-documents.Inspection Unable To Inspect',
        defaultMessage: 'Inspection Unable To Inspect'
    },
    limitChanged: {
        id: 'policy.common.directives.templates.policy-documents.Limit Changed',
        defaultMessage: 'Limit Changed'
    },
    limitLowerThanReplacementCondo: {
        id: 'policy.common.directives.templates.policy-documents.Limit Lower than Replacement Cost - Condo',
        defaultMessage: 'Limit Lower than Replacement Cost - Condo'
    },
    driverInAccident: {
        id: 'policy.common.directives.templates.policy-documents.Loaned Driver Accident',
        defaultMessage: 'Loaned Driver Accident'
    },
    MortgageeNotice: {
        id: 'policy.common.directives.templates.policy-documents.Mortgagee Notice',
        defaultMessage: 'Mortgagee Notice'
    },
    mvrRequest: {
        id: 'policy.common.directives.templates.policy-documents.MVR Request',
        defaultMessage: 'MVR Request'
    },
    needInformation: {
        id: 'policy.common.directives.templates.policy-documents.Need Information',
        defaultMessage: 'Need Information'
    },
    needInspection: {
        id: 'policy.common.directives.templates.policy-documents.Need Inspection',
        defaultMessage: 'Need Inspection'
    },
    newSubmissionDeclineHO: {
        id: 'policy.common.directives.templates.policy-documents.New Submission Decline HO',
        defaultMessage: 'New Submission Decline'
    },
    newSubmissionDeclinePA: {
        id: 'policy.common.directives.templates.policy-documents.New Submission Decline PA',
        defaultMessage: 'New Submission Decline'
    },
    employeeNonRenewalWarning: {
        id: 'policy.common.directives.templates.policy-documents.Non-Renew Warning - Employee',
        defaultMessage: 'Non-Renew Warning - Employee'
    },
    ineligibleRoofMaterialNonRenewalWarning: {
        id: 'policy.common.directives.templates.policy-documents.Non-Renew Warning - Ineligible Roof Material',
        defaultMessage: 'Non-Renew Warning - Ineligible Roof Material'
    },
    ineligibleAnimalNonRenewalWarning: {
        id: 'policy.common.directives.templates.policy-documents.Non-Renew Warning - Ineligible Animal',
        defaultMessage: 'Non-Renew Warning - Ineligible Animal'
    },
    ineligibleBusinessNonRenewalWarning: {
        id: 'policy.common.directives.templates.policy-documents.Non-Renew Warning - Ineligible Business',
        defaultMessage: 'Non-Renew Warning - Ineligible Business'
    },
    noInspectionNonRenewalWarning: {
        id: 'policy.common.directives.templates.policy-documents.Non-Renew Warning - No inspection',
        defaultMessage: 'Non-Renew Warning - No inspection'
    },
    noProofOfRepairNonRenewalWarning: {
        id: 'policy.common.directives.templates.policy-documents.Non-Renew Warning - No Proof of Repair',
        defaultMessage: 'Non-Renew Warning - No Proof of Repair'
    },
    occupancyNonRenewalWarning: {
        id: 'policy.common.directives.templates.policy-documents.Non-Renew Warning - Occupancy',
        defaultMessage: 'Non-Renew Warning - Occupancy'
    },
    lossNonCoopNonRenewal: {
        id: 'policy.common.directives.templates.policy-documents.Loss non Cooperation',
        defaultMessage: 'Loss non Cooperation'
    },
    nonRenewWarning: {
        id: 'policy.common.directives.templates.policy-documents.Non-Renew Warning - Repairs Required',
        defaultMessage: 'Non-Renew Warning - Repairs Required'
    },
    highValueHomes: {
        id: 'policy.common.directives.templates.policy-documents.Non Renew Warning - High Value Homes',
        defaultMessage: 'Non Renew Warning - High Value Homes'
    },
    roommatesNonRenewalWarning: {
        id: 'policy.common.directives.templates.policy-documents.Non-Renew Warning - Roommates',
        defaultMessage: 'Non-Renew Warning - Roommates'
    },
    perjuryLetter: {
        id: 'policy.common.directives.templates.policy-documents.Perjury Letter',
        defaultMessage: 'Perjury Letter'
    },
    policyQuestionnaire: {
        id: 'policy.common.directives.templates.policy-documents.Policy Questionnaire',
        defaultMessage: 'Policy Questionnaire'
    },
    proofOfRepair: {
        id: 'policy.common.directives.templates.policy-documents.Proof Of Repair',
        defaultMessage: 'Proof Of Repair'
    },
    RCTLetter: {
        id: 'policy.common.directives.templates.policy-documents.RCT Letter',
        defaultMessage: 'RCT Letter'
    },
    correspondenceInquiryLetter: {
        id: 'policy.common.directives.templates.policy-documents.Correspondence Inquiry Letter',
        defaultMessage: 'Correspondence Inquiry Letter'
    },
    replacementVehicle: {
        id: 'policy.common.directives.templates.policy-documents.Replacement Vehicle',
        defaultMessage: 'Replacement Vehicle'
    },
    requestLicense: {
        id: 'policy.common.directives.templates.policy-documents.Request License',
        defaultMessage: 'Request License'
    },
    OutOfStateDriverNotice_Ext: {
        id: 'policy.common.directives.templates.policy-documents.Request License',
        defaultMessage: 'Request License'
    },
    scheduledItemRemoval: {
        id: 'policy.common.directives.templates.policy-documents.Scheduled Item Removal',
        defaultMessage: 'Scheduled Item Removal'
    },
    specialProvisionsEndorsement: {
        id: 'policy.common.directives.templates.policy-documents.Special Provisions Endorsement - 125% Dwelling',
        defaultMessage: 'Special Provisions Endorsement - 125% Dwelling'
    },
    specialProvisionEndorsementMortgagee: {
        id: 'policy.common.directives.templates.policy-documents.Special Provisions Endorsement - 125% Dwelling - Mortgagee',
        defaultMessage: 'Special Provisions Endorsement - 125% Dwelling - Mortgagee'
    },
    unreportedAccident: {
        id: 'policy.common.directives.templates.policy-documents.Unreported Accident',
        defaultMessage: 'Unreported Accident'
    },
    verifyCoverageRequest: {
        id: 'policy.common.directives.templates.policy-documents.Verify Coverage Request',
        defaultMessage: 'Verify Coverage Request'
    },
    verifyOccupationAndUsage: {
        id: 'policy.common.directives.templates.policy-documents.Verify occupation and usage',
        defaultMessage: 'Verify occupation and usage'
    },
    verifyVIN: {
        id: 'policy.common.directives.templates.policy-documents.Verify VIN',
        defaultMessage: 'Verify VIN'
    },
    WildfireAppealDecisionPolicy: {
        id: 'policy.common.directives.templates.policy-documents.Wildfire Appeal Decision - Policy',
        defaultMessage: 'Wildfire Appeal Decision - Policy'
    },
    WildfireDiscountCertificationLetterProperty: {
        id: 'policy.common.directives.templates.policy-documents.Wildfire Discount Certification Letter and Form',
        defaultMessage: 'Wildfire Discount Certification Letter and Form(s)'
    },
    cancellationRequestLetter: {
        id: 'policy.common.directives.templates.policy-documents.Cancellation Request Letter',
        defaultMessage: 'Cancellation Request Letter'
    },
    RBNH: {
        id: 'policy.common.directives.templates.policy-documents.Rebranding Cover Letter Homeowners',
        defaultMessage: 'Rebranding Cover Letter'
    },
    RBNA: {
        id: 'policy.common.directives.templates.policy-documents.Rebranding Cover Letter Personal Auto',
        defaultMessage: 'Rebranding Cover Letter'
    }
});
